export const SHOW_NOTIFICATION = "show_notification";
export const HIDE_NOTIFICATION = "hide_notification";
